import type { AxiosInstance } from 'axios'
import type { IReleaseInfo } from '@/typings/releaseInfo'

export default (axios: AxiosInstance) => ({
    getReleaseInfo: async (): Promise<IReleaseInfo> => {
        const { data } = await axios.get<IReleaseInfo>('/guardian/release-info')

        return data
    },
})
